import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import type { Subtitle } from '@types';
import IconTrash from '@components/icons/IconTrash';

interface Props {
  item: Subtitle;
  listIndex: number;
  onClick: (params: { defaultValue: Subtitle; index: number }) => void;
  onDeleteClick: (index: number) => void;
}

export const SidebarSubtitleItem = SortableElement(
  ({ item, listIndex, onClick, onDeleteClick }: Props) => (
    <div
      className="mb-10 flex h-35 cursor-pointer select-none items-center rounded bg-black-#28 px-10 text-base text-white"
      onClick={() => onClick({ index: listIndex, defaultValue: item })}
    >
      <div className="mr-10 truncate">{item.text}</div>
      <IconTrash
        className="ml-auto shrink-0"
        onClick={(e) => {
          e.stopPropagation();
          onDeleteClick(listIndex);
        }}
      />
    </div>
  )
);
